const STORAGE_KEY_PREFIX = 'domain.dido.core.';

export const DIDO_CORE_CONSTANTS = {
    /** Key used as prefix for stuff put in storage (session storage, temp storage, local storage) */
    STORAGE_KEY_PREFIX,
    /** Key used for temp storage */
    TEMP_STORAGE_STATE_KEY: STORAGE_KEY_PREFIX + 'tempState',
    /** Segment in url for dido web */
    DIDO_WEB_URL_SEGMENT: '/a/dido2/web/'
} as const;
